<button [matTooltip]="tooltip" [matTooltipPosition]="position"  class="btn-icon">
    <img src="../../../../assets/images/New design/info.svg" alt="info">
</button>